import { Link } from "react-router-dom";

const stats = [
  { value: "9", label: "精选挠痒视频", icon: "ri-play-circle-line" },
  { value: "8", label: "趣味科普文章", icon: "ri-article-line" },
  { value: "8", label: "社区讨论话题", icon: "ri-chat-smile-2-line" },
  { value: "每周", label: "固定更新时间", icon: "ri-calendar-check-line" },
];

export default function IntroStrip() {
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-12">
      <div className="col-span-1 rounded-lg bg-secondary-100 p-6 md:p-8 lg:col-span-7">
        <p className="flex items-center gap-2 text-[11px] tracking-[0.24em] text-secondary-700 uppercase">
          <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
          关于这个小站
        </p>
        <h2 className="mt-3 font-heading text-2xl leading-snug text-foreground-950 md:text-3xl">
          把趣味做得温和一点，
          <br />
          把放松做得认真一点
        </h2>
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
          挠脚心网站是一个以轻松娱乐为核心的内容平台。我们整理挠痒相关的短片与趣味文章，也留了一块安静的地方给社区讨论。
          有人来这里找三分钟的笑点，有人来这里读一篇轻松的科普，不管哪一种，我们都希望你看完之后比来之前更松弛一点。
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-900 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
          >
            了解我们
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
          <Link
            to="/community"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-50"
          >
            <i className="ri-chat-3-line text-base"></i>
            去社区看看
          </Link>
        </div>
      </div>

      <div className="col-span-1 grid grid-cols-2 gap-3 lg:col-span-5">
        {stats.map((item) => (
          <div
            key={item.label}
            className="flex flex-col justify-between rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-800">
              <i className={`${item.icon} text-base`}></i>
            </span>
            <div className="mt-4">
              <p className="font-heading text-2xl text-foreground-950 md:text-3xl">{item.value}</p>
              <p className="mt-1 text-xs text-foreground-500">{item.label}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}